import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getTagsLookups: ApiMethod<void, Server.TagOutput[], void> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Tags_Client(undefined, contentClient);

    const response = await client.admin_Tags_get_V1();

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const createTag: ApiMethod<
  Server.CreateTagInput,
  Server.TagOutput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Tags_Client(undefined, contentClient);

    const response = await client.admin_Tags_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};
